(function() {
'use strict';

/*
    For the moment the basket service is going to fulfill the workflow role
    i.e. it will act like a state machine to control the transitions that we require
    This might turn out to be wrong but we have no better way to track that state
    at the moment.
*/

angular
    .module('TR')
    .service('basketService', basketService);

function basketService($location,
                       $q,
                       $routeParams,
                       $timeout,
                       $rootScope,
                       $filter,
                       analytics,
                       attractionService,
                       basketStore,
                       bookingService,
                       broker,
                       carHireService,
                       changeDurationPopupService,
                       cookieService,
                       criteoService,
                       currentDestination,
                       dateUtil,
                       enumService,
                       flightSearch,
                       flightsTerminalService,
                       guidService,
                       holidaySearch,
                       hotelSearch,
                       hotelService,
                       insuranceService,
                       loggingService,
                       marhabaSearch,
                       multiSectorSearch,
                       parkingService,
                       resourceService,
                       savedSearchService,
                       searchUnitService,
                       transferSearch,
                       tripService,
                       urlUtils,
                       windowUtil,
                       $window,
                       urlStoreService,
                       mandatoryTransferService
                       ) {
    const holidayBooking = 0;
    const hotelBooking = 1;
    const transferBooking = 2;
    const marhabaBooking = 3;
    const flightBooking = 4;
    const parkingBooking = 6;
    const attractionsBooking = 7;
    const insuranceBooking = 9;
    const autoSearch = 10;

    const workflowType = {
        1: flightBooking,
        2: hotelBooking,
        3: holidayBooking,
        4: transferBooking,
        6: parkingBooking
    };

    let flightUnavailable = false;
    let flightIncompleteDates = false;
    let holidaySearchProgress;
    let flightChanged = true;
    let oldAndNewFlightDatesMatch = false;

    broker.subscribe('basketService', 'flightNotAvailable', function(e) {
        flightUnavailable = true;
        tripService.getTrip(e.data)
            .then(function(trip) {
                const holiday = trip.TripType === tripService.tripTypes.Holiday;
                const flightsRoute = holiday ? 'holidays/flights/' : 'flights/';
                trip.FlightsRequest.SelectedFlight.Unavailable = true;
                tripService.persist(trip.TripId, trip).then(() => $location.url(flightsRoute + trip.TripId));
            });
    });

    broker.subscribe('basketService', 'HotelOptionsAllowed', () => TRPCONFIG.DeviceSettings.HotelOptionsEnabled = true);

    const service = {
        createTrip,
        hotelBooking,
        holidayBooking,
        transferBooking,
        marhabaBooking,
        flightBooking,
        parkingBooking,
        attractionsBooking,
        insuranceBooking,
        autoSearch,
        workflowType,
        startWorkflow,
        startMultiDestHolidayWorkflow,
        completeWorkflow,
        redirectToComplete,
        selectTransfer,
        selectInsurance,
        selectCar,
        selectParking,
        selectMarhaba,
        prepareMarhabaBooking,
        getHotelUrl,
        selectHotel,
        restartCurrentWorkflow,
        restartHolidayWorkflow,
        getFlight,
        getHotel,
        getInsuranceQuotes,
        updateInsuranceQuote,
        changeFlight,
        getTransfers,
        getCarQuotes,
        getCarQuotesFromSession,
        getParkingQuotes,
        getAttractionQuotes,
        getMarhaba,
        bookBasket,
        bookAttractionsBasket,
        selectHotelRooms,
        selectFlight,
        changeToFlightWorkflow,
        changeToHolidayTripType,
        selectMultiFlight,
        updateBasket,
        updateFlight,
        bookingAlreadyDone,
        waitForFlight,
        changeJourneyUrl,
        getHolidaySearchProgress,
        bookHotelBasket,
        getArea,
        isFlightPreselected,
        getHotelDatesFromFlight,
        getNumberOfNightsFromFlights,
        updateBrandedFare
    };

    function changeJourneyUrl(breadcrumb, tripId) {
        const breadcrumbTrail = {
            0: _changeToHome,
            5: _changeToDeal,
            10: _changeToFlight,
            20: _changeToHotel,
            21: _changeToRoom,
            25: _changeToFlight,
            30: _changeToTransfer,
            35: _changeToParking,
            40: _changeToOptions,
            45: _changeToMarhaba,
            50: _changeToInsurance
        };
        if (breadcrumbTrail[breadcrumb] != null) {
            return service.getArea(tripId)
                .then(area => breadcrumbTrail[breadcrumb](tripId || $routeParams.tripId || null, area))
                .then(() => handleMultiDestHolidayExit(tripId));
        }
        loggingService.logError(`changeJourneyUrl: breadcrumb: "${breadcrumb}" doesnt exist for tripId: "${$routeParams.tripId}"`);
        return null;
    }

    function getArea(tripId) {
        return tripService.getTrip(tripId || $routeParams.tripId)
            .then(trip => {
                switch (trip.TripType) {
                    case 1: //flight
                        return 'flights';
                    case 2: //hotel
                        return 'hotels';
                    case 3: //transfer
                        return 'transfers';
                    case 4: //holiday
                        return 'holidays';
                    case 5: // marhaba
                        return 'marhaba'; // ?
                    case 6: // parking
                        return 'parking';
                    case 9: // insurance
                        return 'insurance';
                    default:
                        return '';
                }
            });
    }

    function _startHotelWorkflow(tripId, parameters) {
        sessionStorage.removeItem('preselectedHotelData');
        sessionStorage.removeItem('hasbookingpagevisited');
        sessionStorage.removeItem('PreselectFlight');
        hotelSearch.clearSearchResults(parameters.defaultFilters);
        broker.publish('recommender.startSearch', { searchModel: parameters.searchModel, isHotel: true });
        const errors = hotelSearch.validateSearchCriteria();
        if (errors.length > 0) {
            return $q.reject(errors);
        }
        let createSearchPromise;
        let hotelAvailabilityId;
        let dest;
        let estabId;
        return service.createTrip(tripId, tripService.tripTypes.Hotel)
            .then(() => searchUnitService.updateSearchArea())
            .then(() => {
                broker.publish('newSearchTriggered');
                return parameters.roomSearch ? currentDestination.getCurrentDestination() : searchUnitService.getDestination();
            })
            .then(d => {
                dest = d;
                const customRequest = { TripId: tripId, Destination: dest };
                hotelSearch.buildHotelsRequest(customRequest, searchUnitService.hotel);
                createSearchPromise = hotelSearch.createSearch().then(x => hotelAvailabilityId = x);
                return TRPCONFIG.Domain.ImmediateSearch ? undefined : createSearchPromise;
            })
            .then(() => {
                estabId = parameters.estabId || (dest && dest.EstablishmentId);
                if (parameters.nextUrl !== false) {
                    let url = getHotelUrl({
                        tripId,
                        estabId,
                        isRoomSearch: parameters.roomSearch
                    });
                    $location.url(optionallyAppendParam(url, 'fid', parameters.fid));
                }
                return createSearchPromise;
            })
            .then(() => {
                if (estabId) {
                    hotelService.trackHotelClick(estabId, 0, undefined, undefined, hotelAvailabilityId);
                }
                return savedSearchService.saveHotelSearch(tripId);
            })
            .then(() => ({ hotelAvailabilityId, tripId }));
    }

    function _startAutoSearchWorkflow(tripId, parameters) {
        const isEstabSearch = _.get(parameters, 'destination[0].Type', 0) === 1;
        return isEstabSearch ? _startHotelWorkflow(tripId, parameters) : _startHolidayWorkflow(tripId, parameters);
    }

    function _startHolidayWorkflow(tripId, parameters) {
        return _startFlightPlusWorkflow(tripId, parameters, tripService.tripTypes.Holiday, false)
            .then(() => savedSearchService.saveHolidaySearch(tripId, parameters.searchModel));
    }

    function _startChangeableFlightWorkflowWithProgress(tripId, parameters, progress) {
        return _startFlightPlusWorkflow(tripId, parameters, tripService.tripTypes.Flight, true)
            .then(() => savedSearchService.saveFlightSearch(tripId, parameters.searchModel))
            .then(() => progress && progress.resolve())
            .finally(() => progress = null);
    }

    function _startFlightPlusWorkflow(tripId, parameters, tripType, isFlexibleTripType) {
        broker.publish('recommender.startSearch', { searchModel: parameters.searchModel, isHotel: false });
        sessionStorage.removeItem('PreselectFlight');
        sessionStorage.removeItem('preselectedHotelData');
        sessionStorage.removeItem('hasbookingpagevisited');
        sessionStorage.removeItem('storeSelectedFlight');
        sessionStorage.removeItem('DefaultFlight');
        sessionStorage.removeItem('BrandedFareCancellations');
        sessionStorage.removeItem('hotelSearchResults');
        sessionStorage.removeItem('hotelData');
        sessionStorage.removeItem('destinationAirports');
        sessionStorage.removeItem('selectedFlight');
        sessionStorage.removeItem('selectedHotel');
        sessionStorage.removeItem('HasUpsell');
        if (TRPCONFIG.Domain.IsBrandedFareUpdated) {
            TRPCONFIG.Domain.IsBrandedFareUpdated = false;
        }
        const errors = flightSearch.validateSearchCriteria(true);
        if (errors.length > 0) {
            return $q.reject(errors);
        }
        if (window.location.pathname.includes('flights')) {
            $location.url('');
        }

        return holidaySearch.createSearch(parameters)
            .then(({ data }) => {
                const preselectFlight = (data.PreselectFlight !== undefined && data.PreselectFlight
                                            && data.PackageId === undefined
                                            && TRPCONFIG.Domain.PreselectFlight
                                            && TRPCONFIG.Domain.DeviceType === 'Desktop'
                                            && !TRPCONFIG.Domain.isAgentMode) ||
                                            (data.PreselectFlight !== undefined
                                            && data.PreselectFlight
                                            && data.PackageId === undefined
                                            && TRPCONFIG.Domain.PreselectFlight
                                            && TRPCONFIG.Domain.DeviceType === 'Desktop'
                                            && TRPCONFIG.Domain.isAgentMode
                                            && TRPCONFIG.Domain.isAgentModePreselectFlightEnabled) ||
                                            TRPCONFIG.Domain2.IsHotelFirstJourneyEnabled;
                sessionStorage.setItem('PreselectFlight', !!preselectFlight);
                parameters.FlightSearchId = data && data.FlightSearchId;
                return _startFlightWorkflow(
                    tripId,
                    tripType,
                    () => {
                        hotelSearch.buildHotelsRequest({
                            AvailabilitySearchId: data.HotelSearchId,
                            TripId: tripId,
                            IsFlightPlus: true
                        }, searchUnitService.flight);

                        hotelSearch.setAirportCodeFilter(null);
                        return tripService.recordHotelSearch(tripId, hotelSearch.getAvailabilityRequest())
                            .then(() => tripService.setKidsFree(tripId, data.KidsGoFree));
                    },
                    _.defaults(parameters, { packageId: data.PackageId }),
                    isFlexibleTripType
                );
            }
        );
    }

    function optionallyAppendParam(path, param, value) {
        const querySymbol = path.indexOf('?') >= 0 ? '&' : '?';
        return value ? `${path}${querySymbol}${param}=${value}` : path;
    }

    function _startFlightWorkflow(tripId, flow, hotelSearchFunc, params, isFlexibleTripType) {

        const isFlightType = flow === tripService.tripTypes.Flight;
        const isHolidayType = flow === tripService.tripTypes.Holiday;
        if (!isHolidayType) {
            sessionStorage.setItem('PreselectFlight', false);
        }
        let oneWayOnly = !!searchUnitService.isOneWayFlightEnabled() && isFlightType;

        if (params != null && params.oneWayOnly != null) {
            oneWayOnly = params.oneWayOnly;
        }
        const errors = flightSearch.validateSearchCriteria(!isFlightType, oneWayOnly);
        if (errors.length > 0) {
            return $q.reject(errors);
        }
        flightSearch.clearSearchResults();
        hotelSearch.clearSearchResults(true);
        const isBestFit =
            (params.packageId && TRPCONFIG.Domain.DestinationBasedPackageRates) &&
            isHolidayType;

        return service.createTrip(tripId, flow, null, params.packageId, isFlexibleTripType).then(() => {
            broker.publish('newSearchTriggered');
            if (isBestFit) {
                $location.search('bestfitdeal170', '1');
            }

            // Features that are permanently enabled to all users
            const parasolEnabledFeatures = _.get(TRPCONFIG, 'Domain.ParasolEnabledFeatures');
            const includesEnabledFeature = parasolEnabledFeatures && parasolEnabledFeatures.includes('holidays');

            // Features that are part of a test and can only be access by authenticated users
            const parasolTestingFeatures = _.get(TRPCONFIG, 'Domain2.ParasolTestingFeatures');
            const includesTestingFeature = parasolTestingFeatures && parasolTestingFeatures.includes('holidays');
            const testUserAuthenticated = cookieService.get('x-v3') === 'true' || cookieService.get('x-v3') === _.get(TRPCONFIG, 'Domain.ParasolVWOTestId');

            const isV3HolidayRoute = TRPCONFIG.IsMobileView && (params.packageId === undefined) && (includesEnabledFeature || (testUserAuthenticated && includesTestingFeature));
            const promises = $q.all({
                hotelSearch: hotelSearchFunc ? hotelSearchFunc(tripId) : null,
                flightSearch: flightSearch.search({
                    searchId: params.FlightSearchId || guidService.uuid(),
                    tripId,
                    newSearch: isFlightType,
                    oneWayOnly,
                    flightOnly: isFlightType,
                    flexibleDates: isFlightPreselected() ? false : params.flexibleDates,
                    isV3HolidayRoute,
                    prefilterAirlines: params.prefilterAirlines,
                    postfilterAirlines: params.postfilterAirlines,
                    prefilterDirectFlights: params.prefilterDirectFlights,
                    sortOrder: _getSortOrder(isBestFit, isFlightPreselected()),
                    useSearchUnit: true
                })
            });

            return promises.then(data => {
                if (isBestFit || isFlightPreselected()) {
                    if (data.flightSearch.CombinedDates.AvailableFlights.length) {
                        service.selectFlight(validateNextDayFlight(data.flightSearch.CombinedDates.AvailableFlights), tripId, null, params);
                        if (TRPCONFIG.Domain.EnableHasUpsell) {
                            TRPCONFIG.Domain.flightsUpsellInfo = data.flightSearch.CombinedDates.AvailableFlights.map(({ FlightId, HasUpsell }) => ({ FlightId, HasUpsell }));
                        }
                    } else {
                        $location.url(optionallyAppendParam(`holidays/flights/${tripId}`, 'fid', params.fid));
                    }
                } else if (isHolidayType) {
                    $location.url(optionallyAppendParam(`holidays/flights/${tripId}`, 'fid', params.fid));
                } else {
                    $location.url(optionallyAppendParam(`flights/${tripId}`, 'fid', params.fid));
                }
                criteoService.enqueue([], 'flightlist', flow);
            });
        });
    }

    function _getSortOrder(isBestFit, isHotelFirst) {
        const recommendedSortId = 10;
        const lowestFirstSortId = 1;
        let sortId;
        if (isBestFit) {
            sortId = recommendedSortId;
        } else if (isHotelFirst) {
            sortId = lowestFirstSortId;
        }
        return sortId;
    }

    function getCheckInDateForFlight(flightArrival) {
        const landsAfterCutOff = flightArrival.getHours() >= TRPCONFIG.Domain.DepartureFlightCutOff;
        const zeroTime = dateUtil.zeroTime(flightArrival, true);
        return landsAfterCutOff ? zeroTime : dateUtil.addDays(zeroTime, -1, true);
    }

    function getCheckOutDateForFlight(flightReturn) {
        if (TRPCONFIG.Domain.ReturnFlightCutOff < 0) {
            return dateUtil.zeroTime(flightReturn, true);
        }
        const departsBeforeCutOff = flightReturn.getHours() < TRPCONFIG.Domain.ReturnFlightCutOff;
        const zeroTime = dateUtil.zeroTime(flightReturn, true);
        return departsBeforeCutOff ? dateUtil.addDays(zeroTime, -1, true) : zeroTime;
    }

    function validateNextDayFlight(flights) {
        // To avoid the problem of next day flight causing hotel checkin/checkout dates to be the same
        if (dateUtil.atLeastTwoDaysInTheFuture(flights[0].DepartureDate)) {
            return flights[0];
        }

        const validFlight = _.find(flights, f => {
            const legs = f.Legs;
            const flightArrival = dateUtil.parseDate(legs[0].Segments[legs[0].Segments.length - 1].ArrivalDate);
            const flightReturn = legs.length > 1 ? dateUtil.parseDate(legs[legs.length - 1].Segments[0].DepartureDate) : null;

            return dateUtil.getDifferenceInDays(
                new Date(getCheckInDateForFlight(flightArrival)),
                new Date(getCheckOutDateForFlight(flightReturn))
                ) > 0;
        });

        return validFlight;
    }

    function _startMultiFlightWorkflow(tripId, params) {
        const errors = multiSectorSearch.validateSearchCriteria(params);
        if (errors.length > 0) {
            return $q.reject(errors);
        }

        return createTrip(tripId, tripService.tripTypes.Flight)
            .then(function() {
                $location.path(`multiflights/${tripId}`);
                return multiSectorSearch.search(tripId, params);
            });
    }

    function _startTransferWorkflow(tripId, parameters) {
        transferSearch.clearSearchResults();
        if (!TRPCONFIG.Domain.PointToPointTransferSearchEnabled) {
            searchUnitService.setLocationId(null);
        }
        const errors = transferSearch.validateSearchCriteria({ enableTransfersTimeApproval: parameters.enableTransfersTimeApproval });
        if (errors.length > 0) {
            return $q.reject(errors);
        }
        return service.createTrip(tripId, tripService.tripTypes.Transfer).then(function() {
            $location.path(`transfers/${tripId}`);
            return transferSearch.search({ searchId: guidService.uuid(), tripId, newSearch: true, isFlightPlus: false }).then(savedSearchService.saveTransferSearch);
        });
    }

    function _startMarhabaWorkflow(tripId) {
        marhabaSearch.clearSearchResults();
        const errors = marhabaSearch.validateSearchCriteria();
        if (errors.length > 0) {
            return $q.reject(errors);
        }
        return service.createTrip(tripId, tripService.tripTypes.Marhaba).then(function() {
            $location.path(`marhaba/${tripId}`);
            return marhabaSearch.search({ searchId: guidService.uuid(), tripId, newSearch: true });
        });
    }

    function _startParkingWorkflow(tripId) {
        parkingService.clearSearchResults();
        const errors = parkingService.validateSearchCriteria();

        if (errors.length > 0) {
            return $q.reject(errors);
        }

        return service.createTrip(tripId, tripService.tripTypes.Parking)
            .then(() => parkingService.getParkingQuotes(tripId))
            .then(() => $location.path(`parking/${tripId}`))
            .then(() => savedSearchService.saveParkingSearch(tripId));
    }

    function _startAttractionsWorkflow(params) {
        return basketStore.getAttractionsBasketId()
            .then(basketId => basketStore.addAttraction(params.productId, params.productTags, basketId))
            .then(basketData => {
                if (basketData.error) { return; }
                const changeData = basketData.Change;
                let lineItems = changeData && changeData.New || [];
                if (!lineItems.length) {
                    // No new items, check if a product already in the basket was modified
                    lineItems = attractionService.getLineItemChanges(basketData);
                }
                return lineItems;
            });
    }

    function _startInsuranceWorkflow(tripId) {
        insuranceService.clearSearchResults();
        const errors = insuranceService.validateSearchCriteria();
        if (errors.length > 0) {
            return $q.reject(errors);
        }
        return service.createTrip(tripId, tripService.tripTypes.Insurance).then(function() {
            $location.path(`insurance/results/${tripId}`);
            return insuranceService.search({ searchId: guidService.uuid(), tripId, newSearch: true })
                .then(savedSearchService.saveInsuranceSearch);
        });
    }

    function _prepareBooking(tripId, path, v3 = false) {
        return tripService.setBookingId(tripId, guidService.uuid())
            .then(function(trip) {
                return bookingService.prepareBooking(trip.BasketId, trip.BookingId, tripId)
                    .then(preparedBooking => {
                        if (v3) {
                            $window.location.href = `booking/summary/${tripId}?gov=3`;
                        } else {
                            $location.path(`${path}/${tripId}`);
                        }
                        return preparedBooking;
                    });
            });
    }

    function startWorkflow(type, parameters) {
        const tripId = guidService.uuid();
        const requestedUrl = $location.url();
        const source = $routeParams.source;

        const result = startWorkflowInternal(type, parameters, tripId);

        if (result && type !== attractionsBooking) { // No trip data for attractions
            result.then(() => {
                analytics.trackSearchOrigin(tripId, requestedUrl);
                if (source) {
                    $location.search('source', source);
                }
            });
        }
        return result;
    }

    async function startMultiDestHolidayWorkflow() {
        try {
            const query = $location.search();
            const variantKey = 'variant';
            const variant = query && variantKey in query && Number(query[variantKey]) || undefined;
            const basket = await basketStore.createBasket(true /* ForHoliday */); // Usually created in `createTrip`
            const basketId = basket.BasketId;
            const tripId = await hotelSearch.createMultiDestHolidaySearch(basketId, variant);

            if (basketId && tripId) {
                searchUnitService.setDestination(null);
                const trip = await tripService.getTrip(tripId);
                await tripService.persist(tripId, Object.assign({}, trip, { BasketId: basketId }));
                analytics.trackSearchOrigin(tripId, $location.url());
                $location.path(`/holidays/january-sale/${tripId}`).search(_.omit(query, variantKey));
            }
        } catch (err) {
            loggingService.logError('Multi destination holiday search failed', JSON.stringify(err));
            $location.path('/error');
        }
    }

    async function handleMultiDestHolidayExit(tripId = $routeParams.tripId) {
        // Change to holiday type if currently in multi destination holiday flow
        const trip = await tripService.getTrip(tripId);
        if (trip.TripType === tripService.tripTypes.MultiDestHoliday) {
            return tripService.changeTripType(tripId, tripService.tripTypes.Holiday);
        }
    }

    function getHolidaySearchProgress() {
        return holidaySearchProgress && holidaySearchProgress.promise || $q.when();
    }

    function startWorkflowInternal(type, parameters, tripId) {
        if (!parameters) {
            parameters = {};
        }
        if (type === flightBooking) {
            const flightDestinationKeys = _.keys(searchUnitService.getDestination());
            const isntFlexibleFlightDestination = flightDestinationKeys[0] === 'Title' && flightDestinationKeys.length === 1;

            if (parameters.multi) {
                return _startMultiFlightWorkflow(tripId, parameters);
            }
            if (isntFlexibleFlightDestination) {
                return _startFlightWorkflow(tripId, tripService.tripTypes.Flight, null, parameters, false)
                    .then(() => savedSearchService.saveFlightSearch(tripId, parameters.searchModel));
            }
            if (TRPCONFIG.Domain.HotelsOnFlightsEnabled) {
                holidaySearchProgress = $q.defer();
                return _startChangeableFlightWorkflowWithProgress(tripId, parameters, holidaySearchProgress);
            }
            return _startFlightWorkflow(tripId, tripService.tripTypes.Flight, null, parameters, false)
                .then(() => savedSearchService.saveFlightSearch(tripId, parameters.searchModel));
        }
        if (type === hotelBooking) {
            hotelSearch.setAirportCodeFilter(null);
            return _startHotelWorkflow(tripId, parameters);
        }
        searchUnitService.setDefaultCurrency();
        if (type === holidayBooking) {
            holidaySearchProgress = $q.defer();
            if (parameters.isFlexibleTripType) {
                return _startChangeableFlightWorkflowWithProgress(tripId, parameters, holidaySearchProgress);
            }
            return _startHolidayWorkflow(tripId, parameters)
                .then(() => holidaySearchProgress && holidaySearchProgress.resolve())
                .finally(() => holidaySearchProgress = null);
        }
        if (type === transferBooking) {
            return _startTransferWorkflow(tripId, parameters);
        }
        if (type === marhabaBooking) {
            return _startMarhabaWorkflow(tripId, parameters);
        }
        if (type === parkingBooking) {
            return _startParkingWorkflow(tripId, parameters);
        }
        if (type === attractionsBooking) {
            return _startAttractionsWorkflow(parameters);
        }
        if (type === insuranceBooking) {
            return _startInsuranceWorkflow(tripId, parameters);
        }
        if (type === autoSearch) {
            return _startAutoSearchWorkflow(tripId, parameters);
        }
    }

    function createTrip(TripId, TripType, basketId, PackageId, FlexibleTripType) {
        return $q.when(
            basketId ||
            basketStore.createBasket(TripType === tripService.tripTypes.Holiday)
                .then(({ BasketId }) => BasketId)
        )
        .then(BasketId => tripService.persist(TripId, {
            BasketId,
            FlexibleTripType,
            PackageId,
            TripId,
            TripType
        }));
    }

    function completeWorkflow(refs, basketId) {
        return $q.all([
            basketStore.all(basketId),
            basketStore.totalCost(basketId),
            basketStore.getBasketCurrency(basketId)
        ]).then(([basket, total, currency]) => {
            broker.publish('bookingComplete', { refs, basket, total, currency });
            return basketStore.clearBasket(basketId).then(() => {
                return [basket, total, currency];
            });
        });
    }

    function redirectToComplete(refs, basketId, totalCost, tripId) {
        const refRoute = refs.join('|');
        let url = `/booking/complete/${refRoute}?tripId=${tripId}`;
        if (TRPCONFIG.Domain.BuyNowPayLaterEnabled && totalCost > TRPCONFIG.Domain.BuyNowPayLaterCost) {
            url = `${url}&pl=1`;
        }
        if (TRPCONFIG.Domain.ParasolBookingComplete) {
            //Leave some time for tracking to complete:
            setTimeout(() => window.location = url, 333);
        } else {
            $location.url(url);
        }
    }

    function _changeToHome(tripId, area) {
        $location.url(TRPCONFIG.Domain.SearchUnitHomePath + area);
    }

    function _changeToDeal(tripId) {
        return tripService.getTrip(tripId).then(trip => {
            if (trip && trip.Deal) {
                $location.url(urlUtils.stripLeadingSlash(trip.Deal.OriginPath));
            }
        });
    }

    function _changeToFlight(tripId) {
        return tripService.getTrip(tripId)
            .then(({ FlexibleTripType, TripType, HotelsRequest }) => {
                if (TripType === tripService.tripTypes.MultiDestHoliday ||
                    // On the booking form, TripType changes to Holiday so test for Destinations prop
                    (HotelsRequest && HotelsRequest.Destinations)) {
                    return searchUnitService.setDestination(HotelsRequest.Destination)
                        .then(() => startWorkflow(holidayBooking));
                }
                return $location.path(`${TripType === tripService.tripTypes.Holiday && !FlexibleTripType ? 'holidays/' : ''}flights/${tripId}`);
            });
    }

    function _changeToHotel(tripId, area) {
        return tripService.setDirectToHotel(tripId, false).then(function() {
            $location.path(`${area}/${area === 'holidays' ? 'hotels/' : ''}${tripId}`);
        });
    }

    function _changeToRoom(tripId, area) {
        return tripService.getTrip(tripId).then(function(trip) {
            basketStore.hotel(trip.BasketId).then(function(hotel) {
                $location.path(`${area}/${tripId}/${hotel.Details.Id}`);
            });
        });
    }

    function _changeToTransfer(tripId) {
        $location.path(`transfers/${tripId}`);
    }

    function _changeToParking(tripId) {
        $location.path(`parking/${tripId}`);
    }

    function _changeToMarhaba(tripId) {
        $location.path(`marhaba/${tripId}`);
    }

    function _changeToInsurance(tripId) {
        $location.path(`insurance/results/${tripId}`);
    }

    function _changeToOptions(tripId, area) {
        $location.path(`${area}/options/${tripId}`);
    }

    function getBookingPath(trip) {
        const isMeta = _.get($location.search(), 'source') === 'TV';
        const isHolidayDeal = _.get(trip, 'FromHolidayDeal');
        const isHoliday = _.get(trip, 'TripType') === 4;

        if (isHolidayDeal) {
            return isHoliday ? 4 : 3;
        }

        if (isMeta) {
            return isHoliday ? 6 : 5;
        }

        return isHoliday ? 2 : 1;
    }

    function selectTransfer(id, searchId, basketId, tripId) {

        let isObject = typeof id === 'object' && id !== null;
        let prodType;
        let preselectedHotelData;
        let options;
        if (isObject) {
            prodType = basketStore.productType.Transfer;
        } else {
            prodType = basketStore.productType.Accommodation;
            preselectedHotelData = JSON.parse(sessionStorage.getItem('preselectedHotelData'));

            options = [{ OptionId: id }];
            /* If more than One Room */
            if (options && preselectedHotelData && preselectedHotelData.d.BookedItems &&
                preselectedHotelData.d.BookedItems.length > 1) {
                let perRoomExtra = [];
                preselectedHotelData.d.BookedItems.forEach(room => {
                    let roomNum = `HotelExtra|${room.RoomNumber}|`;
                    let roomExtra = { OptionId: id.replace('HotelExtra|0|', roomNum) };
                    perRoomExtra.push(roomExtra);
                });
                options = perRoomExtra;
            }
        }

        return basketStore.transfer(basketId).then(function(t) {
            if (!isObject && basketId) {
                service.updateBasket();
                return basketStore.hotel(basketId).then(function(h) {
                let extra;
                if (h && h.CostBreakdown) {
                    h.CostBreakdown.forEach(cb => {
                        extra = cb.ExtraReference ? cb.ExtraReference : '';
                    });
                }
                if (extra.split('|')[2] !== options[options.length - 1].OptionId.split('|')[3]) {
                    return basketStore.addTransfer(
                        prodType, searchId, options, basketId).then(function(transfer) {
                        return transfer;
                    });
                }
                return h;
            });
            } else if (t == null || t.Details.TransferId !== id) {
                return basketStore.addTransfer(
                    prodType, searchId, id, basketId).then(function(transfer) {
                    service.updateBasket();
                    return basketStore.all(basketId).then(function(products) {
                        if (products.t && !products.h && !products.f) {
                            _prepareBooking(tripId, 'transfers/book');
                        }
                        return transfer;
                    });
                });
            }
            return t;
        });
    }

    function selectInsurance(quote, searchId, basketId, tripId) {
        return basketStore.insurance(basketId)
            .then(function() {
                return basketStore.addInsurance(searchId, quote, basketId).then(function(insurance) {
                    service.updateBasket();
                    return basketStore.all(basketId).then(function(products) {
                        if (products.i && !products.h && !products.f) {
                            _prepareBooking(tripId, 'insurance/book');
                        }
                        return insurance;
                    });
                });
            });
    }

    function selectCar(quote, searchId, basketId) {
        return basketStore.addCar(searchId, quote, basketId).then(carhire => {
            service.updateBasket();
            return carhire;
        });
    }

    function selectParking(id, searchId, basketId, tripId) {
        let parking;

        return basketStore.addParking(searchId, id, basketId)
            .then(p => {
                parking = p;
                service.updateBasket();
                return basketStore.all(basketId);
            })
            .then(({ p, h, f }) => {
                // Assume standalone parking if no hotel or flight
                if (p && !h && !f) {
                    _prepareBooking(tripId, 'parking/book');
                }
                return parking;
            });
    }

    function selectMarhaba(tripId, parameters) {
        return _startMarhabaWorkflow(tripId, parameters);
    }

    function prepareMarhabaBooking(tripId, productId) {
        return tripService.setBookingId(tripId, guidService.uuid())
            .then(function(trip) {
                return bookingService.prepareBooking(trip.BasketId, trip.BookingId, tripId)
                    .then(preparedBooking => {
                        $location.path(`marhaba/book/${tripId}/${productId}`);
                        return preparedBooking;
                    });
            });
    }

    function getHotelUrl({ tripId, hotel, flight, estabId, isRoomSearch = true, TripType }) {
        estabId = estabId || _.get(hotel, 'Id');
        let isAmmendBooking = !!$routeParams.BookingRef;
        const isHolidays = flight || TripType === tripService.tripTypes.Holiday;
        let url = isAmmendBooking ? `dashboard/amend-booking/${$routeParams.BookingRef}/${$routeParams.BookingId}` :
            isHolidays ? 'holidays' :
            'hotels';

        url += `/${tripId}`;

        if (estabId && (TRPCONFIG.Domain.HotelSearchNoResultsPage !== 'availability' || isRoomSearch)) {
            url += `/${estabId}`;
        }

        let search = _.omit($location.search(), '__bd4sort');

        let querystring = $.param(search);
        if (querystring) {
            url += `?${querystring}`;
        }
        return url;
    }

    function getDataLayer() {
        const excludedGAItems = ['config', 'utmId'];
        const gaEvents = ['gtm.js', 'gtm.dom', 'gtm.load'];
        let dataLayerItems = [];
        window.dataLayer.forEach(dl => {
                const dlKeys = Object.keys(dl);
                const commonItems = dlKeys.filter(item => excludedGAItems.includes(item));
                if (!commonItems[0]) {
                    if (!gaEvents.includes(dl.event)) {
                        dataLayerItems.push(dl);
                    }
                }
        });
        localStorage.setItem('gaSession', JSON.stringify(dataLayerItems));
    }

    document.addEventListener('contextmenu', function() {
        getDataLayer();
    });

    function sendDataToDataLayer() {
        let gaHotelTracking = JSON.parse(localStorage.getItem('gaHotelTracking'));
        let gaHotelSearch = JSON.parse(localStorage.getItem('gaHotelSearch'));
        if (gaHotelTracking && gaHotelSearch) {
            analytics.track('Event', 'SelectHotel', gaHotelTracking);
            analytics.trackEvent(gaHotelSearch);
        }
    }

    // Listen for visibility change events. This helps with detecting a new tab opening.
    document.addEventListener('visibilitychange', function() {
        // The idea here, is that we combine ALL 'lost' session storages into one local storage. This example is only for session searchDates.

        sendDataToDataLayer();

        if (document.visibilityState === 'hidden') {
            // To set local storage from session storage
            const sessionItems = [
                'PreselectFlight',
                'storeSelectedFlight',
                'searchDates',
                'URLstorage',
                'FlightDetailsId',
                'priceQtys',
                'hotelSearchResults',
                'DefaultFlight',
                'SkywardsMilesFlights'
            ];
            const theSearchDates = sessionStorage.getItem('searchDates');

            let obj = Object.keys(sessionStorage).reduce(function(obj, key) {
                if (sessionItems.includes(key)) {
                    obj[key] = sessionStorage.getItem(key);
                }
                return obj;
            }, {});
            if (theSearchDates && !localStorage.getItem('sessionStorageData')) {
                if (obj !== null) {
                    localStorage.setItem('sessionStorageData', JSON.stringify(obj));
                }
            }
            if (localStorage.getItem('gaSession') && localStorage.getItem('gaHotelTracking') && localStorage.getItem('gaHotelSearch')) {
                localStorage.removeItem('gaSession');
                localStorage.removeItem('gaHotelTracking');
                localStorage.removeItem('gaHotelSearch');
            }
        } else {
            // To fetch local storage and set session storage in new tab
            const theSearchDates = sessionStorage.getItem('searchDates');
            if (!theSearchDates && localStorage.getItem('sessionStorageData')) {
                copyLocalToSessionStorage();
            } else {
                // when local storage not present then fetch on the storage event
                window.addEventListener('storage', function(e) {
                    if (e.key === 'sessionStorageData') {
                        copyLocalToSessionStorage();
                    }
                });
            }
        }
    });

    function copyLocalToSessionStorage() {
        let gaSessionData = localStorage.getItem('gaSession');
        gaSessionData = JSON.parse(gaSessionData);
        if (gaSessionData) {
            let uniqueResult = gaSessionData.filter(function(dlNew) {
                return !window.dataLayer.some(function(dlOriginal) {
                    return _.isEqual(dlOriginal, dlNew);
                });
            });
            window.dataLayer = uniqueResult ? uniqueResult.concat(window.dataLayer) : window.dataLayer;
        }
        let sessionStorageData = localStorage.getItem('sessionStorageData');
        sessionStorageData = JSON.parse(sessionStorageData);
        for (let key in sessionStorageData) {
            if (sessionStorageData.hasOwnProperty(key)) {
                sessionStorage.setItem(key, sessionStorageData[key]);
            }
        }
        if (sessionStorage.getItem('searchDates')) {
            localStorage.removeItem('sessionStorageData');
        }
    }

    function selectHotel(tripId, hotel, basketId, area, sameWindow, newTab) {
        tripService.setDirectToHotel(tripId, false);
        basketStore.flight(basketId)
            .then(function(flight) {
                if (flightUnavailable) {
                    return;
                }
                const url = getHotelUrl({ tripId, hotel, flight });
                if (newTab) {
                    windowUtil.open(url);
                } else if (TRPCONFIG.DeviceSettings.OpenHotelInNewWindow && !sameWindow) {
                    windowUtil.open(url);
                } else {
                    $location.url(url);
                }
            });
    }

    function restartCurrentWorkflow(tripId) {
        tripService.getTrip(tripId)
            .then(function(trip) {
                basketStore.all(trip.BasketId)
                    .then(function(products) {
                        if (products.t != null) {
                            $location.path('transfers');
                        } else if (products.f != null) {
                            $location.path('holidays');
                        } else {
                            $location.path('hotels');
                        }
                    });
            });
    }

    function restartHolidayWorkflow() {
        $location.path('holidays');
    }

    function getFlight(basketId) {
        return basketStore.flight(basketId);
    }

    function getHotel(basketId) {
        return basketStore.hotel(basketId);
    }

    function changeFlight(tripId) {
        $location.path(`holidays/flights/${tripId}`);
    }

    function getTransfers(searchId, basketId, tripId, params = {}) {
        if (searchId) {
            return transferSearch.getSearchResults(searchId, tripId);
        }

        return basketStore.all(basketId).then(function(products) {
            if (params.airport && params.dates) {
                searchUnitService.startDate(searchUnitService.transfer, _(params).get('dates.arrivalDate'));
                searchUnitService.endDate(searchUnitService.transfer, _(params).get('dates.departureDate'));
                searchUnitService.setDestinationAirport(params.airport);
            } else {
            const legs = _.get(products, 'f.Details.Itinerary.Legs', []);
            searchUnitService.startDate(searchUnitService.transfer, legs[0].ArrivalDate);
            if (legs.length > 1) {
                searchUnitService.endDate(searchUnitService.transfer, legs[legs.length - 1].DepartureDate);
            }
                searchUnitService.setDestinationAirport(legs[0].ArrivalAirport);
            }

            if (products.h != null) {
                searchUnitService.setLocationId(products.h.Details.LocationId);
            }
            const errors = transferSearch.validateSearchCriteria();
            if (errors.length > 0) {
                return $q.when([]);
            }
            const args = { searchId: guidService.uuid(), newSearch: true, tripId, isFlightPlus: true };
            if (products.h && products.h.FuturePayments.length) {
                args.BalanceDueDateOverride = products.h.FuturePayments[products.h.FuturePayments.length - 1].Due;
            }
            return transferSearch.search(args);
        });
    }

    function getInsuranceQuotes(searchId, basketId, tripId, params = {}) {
        if (searchId) {
            return insuranceService.getInsuranceQuotesFromSession(searchId);
        }

        return $q.all({
            flight: basketStore.flight(basketId),
            hotel: basketStore.hotel(basketId)
        }).then(({ flight, hotel }) => {
            if (flight == null && hotel == null) { return $q.when([]); }

            const legs = _.get(flight, 'Details.Itinerary.Legs');

            const search = function(ageList) {
                const request = {
                    AvailabilitySearchId: guidService.uuid(),
                    DestinationAirportCode: _.get(params, 'airport.Code') || legs[0].ArrivalAirport.Code,
                    StartDate: _.get(params, 'dates.arrivalDate') || legs[0].DepartureDate,
                    Ages: ageList
                };

                request.EndDate = _.get(params, 'dates.departureDate') || (params.oneWayOnly ? legs[0].ArrivalDate
                : legs[legs.length - 1].ArrivalDate);

                return insuranceService.getInsuranceQuotes(tripId, request);
            };

            if (params.ages) {
                return search(params.ages);
            }

            return tripService.getTripReducedOccupancy(tripId).then(o => {
                const ages = _.concat(_.times(o.Adults, () => 21), o.ChildAges);
                return search(ages);
            });
        });
    }

    function updateInsuranceQuote(basketId, tripId, selectedOptionId, params) {
        // tackle a scenario when quote is updated by navigating to booking form rather than user action
        // in that case do not remove it
        if (!selectedOptionId) {
            return $q.when([]);
        }

        if (!params.ages || params.ages.length === 0) {
            return basketStore.removeInsurance(basketId);
        }

        //need to update the quote we have
        // get existing quote, make a new request, find the selected option and add it to the basket
        const key = insuranceService.decomposeOptionId(selectedOptionId);

        //remove existing
        return basketStore.removeInsurance(basketId).then(function() {
            //get new quotes
            return getInsuranceQuotes(null, basketId, tripId, params);
        }).then(function(insuranceQuotes) {
            //find the same type
           return _.filter(insuranceQuotes, function(q) {
                return q.SupplierId === key.supplierId && q.QuoteType.SchemeId === key.schemeId && q.QuoteType.TypeId === key.typeId;
            });
        }).then(function(quotes) {
            //add it to our basket
            return tripService.getTrip(tripId).then(function(trip) {
                return selectInsurance(quotes[0], trip.InsuranceRequest.AvailabilitySearchId, basketId, tripId);
            });
        });
    }

    function getMarhaba(searchId, basketId, tripId, parameters) {
        if (!searchId) {
            searchId = guidService.uuid();
        }
        $location.url(`marhaba/${tripId}`);
        return marhabaSearch.search({ searchId, tripId, newSearch: true, parameters });
    }

    function bookBasket(tripId, basketId) {
        return basketStore.flight(basketId)
            .then(function(f) {
                if (f) {
                    return _prepareBooking(tripId, 'holidays/book');
                }
            });
    }

    function bookAttractionsBasket(tripId = guidService.uuid()) {
        basketStore.getAttractionsBasketId()
            .then(basketId => createTrip(tripId, tripService.tripTypes.Attractions, basketId))
            .then(() => _prepareBooking(tripId, 'attractions/book'));
    }

    function selectHotelRooms(hotel, roomIds, tripId) {
        if (flightUnavailable) {
            return;
        }
        let selectRoomFirstTime = sessionStorage.getItem('preselectedHotelData') === null;
        $q.all({
            trip: tripService.clearOptionalExtras(tripId),
            numberOfNights: tripService.getHotelsRequestNumberOfNights(tripId),
            currency: tripService.getCurrency(tripId)
        })
        .then(({ trip, numberOfNights, currency }) => {
            if (trip && trip.HotelsRequest) {
                const bookingPath = getBookingPath(trip);
                let rebookId = $routeParams.BookingId;

                basketStore.addHotel(
                    trip.HotelsRequest.AvailabilitySearchId,
                    hotel.Id,
                    roomIds,
                    trip.BasketId,
                    bookingPath,
                    trip.PackageId,
                    rebookId
                )
                .then(res => {
                    basketStore.flight(trip.BasketId)
                        .then(f => {
                            const options = mandatoryTransferService.getOptions();
                            if (TRPCONFIG.Domain.MandatoryExtrasEnabled && options) {
                                basketStore.addOptions(basketStore.productType.Transfer, res.ProductId, options, trip.BasketId);
                            }
                            broker.publish('roomsAddedToBasket', hotel);
                            service.updateBasket();
                            if (f) {
                                if (isFlightPreselected() && (!flightChanged || selectRoomFirstTime)) {
                                    $location.path(`holidays/flights/${tripId}`);
                                } else {
                                    //Added below if else to handle case while coming from emirates.com/deeplink if we have more then 1 flight then show Choose you flight screen
                                    // eslint-disable-next-line no-lonely-if
                                    if (sessionStorage.getItem('IsDeepLinkURL')) {
                                        sessionStorage.removeItem('IsDeepLinkURL');
                                        $location.path(`holidays/flights/${tripId}`);
                                    } else {
                                        $location.path(`holidays/options/${tripId}`);
                                    }
                                }
                            } else if (
                                TRPCONFIG.DeviceSettings.HotelOptionsEnabled
                                && TRPCONFIG.Domain.CurrencyCode === currency
                                && TRPCONFIG.Domain.HotelOptionsMinDuration
                                && numberOfNights >= TRPCONFIG.Domain.HotelOptionsMinDuration
                                && hotel.LinkedAirports
                                && hotel.LinkedAirports.length
                                && !_.intersection(hotel.LinkedAirports.map(a => a.Code), TRPCONFIG.Domain.HotelOptionsFilterOutAirportCodes).length
                            ) {
                                $location.path(`hotels/options/${tripId}`);
                            } else {
                                let totalRooms = trip.HotelsRequest.Rooms && trip.HotelsRequest.Rooms.length || 0;
                                let singleRoomOnly = TRPCONFIG.Domain.ParasolHotelBookingSingleRoomOnly
                                    && totalRooms === 1;
                                let isMobile = TRPCONFIG.IsMobileView;
                                let goV3 = isMobile && (TRPCONFIG.Domain.ParasolHotelBooking && singleRoomOnly)
                                    || (TRPCONFIG.Domain.ParasolHotelBooking && !TRPCONFIG.Domain.ParasolHotelBookingSingleRoomOnly);
                                _prepareBooking(tripId, 'hotels/book', goV3);
                            }
                        });
                });
            }
        });
    }

    function bookHotelBasket(tripId) {
        _prepareBooking(tripId, 'hotels/book');
    }

    function updateBrandedFare(params) {
        return basketStore.updateBrandedFare(params)
            .then(f => {
                broker.publish('flightAddedToBasket', f);
                service.updateBasket();
            });
    }

    function showChangeHotelsDurationConfirmationPopup(flight) {
        const legs = flight.Legs;
        const flightArrival = (legs && legs[0].Segments) ? dateUtil.parseDate(legs[0].Segments[legs[0].Segments.length - 1].ArrivalDate) : null;
        const flightReturn = (legs && legs.length > 1) ? dateUtil.parseDate(legs[legs.length - 1].Segments[0].DepartureDate) : null;
        const zeroTime = dateUtil.zeroTime(flightArrival, true);
        const checkInDate = dateUtil.format(flightArrival, 'dd MMMM yyyy');
        const checkInTime = dateUtil.format(flightArrival, 'HH:mm');
        const newCheckInDate = dateUtil.format(dateUtil.addDays(zeroTime, -1, true), 'dd MMMM yyyy');
        const nights = dateUtil.numberOfNights(flightArrival, flightReturn);
        const newNights = dateUtil.numberOfNights(dateUtil.addDays(zeroTime, -1, true), flightReturn);
        const headerText = resourceService.get('CHANGENIGHTSPOPUPHEADER');
        const messageText = String.format(resourceService.get('CHANGE_HOTEL_CHECKIN_POPUP_MSG'), checkInDate, checkInTime, checkInDate, nights, newCheckInDate, newNights);
        const nightsText = resourceService.get('NIGHTS');
        const nightsButtonLabel = `${nights} ${nightsText}`;
        const newNightsButtonLabel = `${newNights} ${nightsText}`;
        const dateTemplate = messageText;
        let messageHtml = dateTemplate;
        return changeDurationPopupService.showPopup({
            popupHeader: headerText,
            popupMessage: messageHtml,
            nightsButtonLabel,
            newNightsButtonLabel
        });
    }

    function _block() {
        $rootScope.$emit('block', {
            title: resourceService.get('SEARCHINGHOTELS'),
            subtitle: resourceService.get('THISMAYTAKE'),
            loadingScreenStyle: 'holidays-hotelSearchCtrl-isHolidayTrue'
        });
    }

    function selectFlight(flight, tripId, opts, params, mobileParams = {}, forceRedirectToOptions = false) {
        //if the flight does not contain full date information (AVRO), then we
        //have to wait until after the detail call has completed before moving on to
        //the hotel route

        let defaultFlight = sessionStorage.getItem('DefaultFlight') ? JSON.parse(sessionStorage.getItem('DefaultFlight')) : null;
        const { HasFullDates, Legs } = flight;
        const airportCodeFilter = TRPCONFIG.Domain.AutoFilterByAirport ? Legs[0].ArrivalAirport.Code : null;
        let storeSelectedFlight = sessionStorage.getItem('storeSelectedFlight');
        storeSelectedFlight = JSON.parse(storeSelectedFlight !== null ? storeSelectedFlight : '{}');
        let isNewFlight = false;
        isNewFlight = (storeSelectedFlight && storeSelectedFlight.FlightId) || (defaultFlight && defaultFlight.FlightId) ? isNewFlight : !isNewFlight;
        const flightComparisonResult = (storeSelectedFlight && storeSelectedFlight.FlightId) ? _compareFlights(storeSelectedFlight, flight) :
        (defaultFlight && defaultFlight.Details.Itinerary) ? _compareFlights(defaultFlight.Details.Itinerary, flight) : _compareFlights({}, flight);
        flightChanged = flightComparisonResult.isDifferentFlights;
        oldAndNewFlightDatesMatch = flightComparisonResult.isDatesMatch;
        const preselectedHotelData = sessionStorage.getItem('preselectedHotelData');
        if (TRPCONFIG.Domain.EnableHasUpsell) {
            TRPCONFIG.Domain.HasUpsell = flight.HasUpsell;
        }
        flightUnavailable = false;
        flightIncompleteDates = !HasFullDates;
        TRPCONFIG.Domain.ChangeHotelNightsDuration = false;
        hotelSearch.setAirportCodeFilter(airportCodeFilter);
        sessionStorage.setItem('storeSelectedFlight', JSON.stringify(flight));
        if (flight && flight.Legs && flight.Legs[0].ArrivalAirport && flight.Legs[0].ArrivalAirport.Code) {
            flightSearch.getDestinationAirports(flight.Legs[0].ArrivalAirport.Code).then(result => {
                if (result && result.data) {
                    sessionStorage.setItem('destinationAirports', JSON.stringify(result.data));
                }
            });
        }
        if (flight && flight.Legs && flight.Legs[0].DepartureAirport && flight.Legs[0].DepartureAirport.Code) {
            flightSearch.getDestinationAirports(flight.Legs[0].DepartureAirport.Code).then(result => {
                if (result && result.data) {
                    sessionStorage.setItem('originAirports', JSON.stringify(result.data));
                }
            });
        }
        return tripService.getTrip(tripId).then(trip => {
            if (trip) {
                const { BasketId, FlexibleTripType, FlightsRequest, HotelsRequest, PackageId, TripType } = trip;
                const hotelsRequest = trip.HotelsRequest;
                const legs = flight.Legs;
                const flightArrival = (legs && legs[0].Segments) ? dateUtil.parseDate(legs[0].Segments[legs[0].Segments.length - 1].ArrivalDate) : null;
                const flightReturn = (legs.length > 1 && legs[legs.length - 1].Segments) ? dateUtil.parseDate(legs[legs.length - 1].Segments[0].DepartureDate) : null;
                const isFlightType = TripType === tripService.tripTypes.Flight;
                const isHolidayType = TripType === tripService.tripTypes.Holiday;
                const isMultiDestHolidayType = TripType === tripService.tripTypes.MultiDestHoliday;
                const isDirectFlight = _.reduce(Legs, (result, value) => result.NumberOfStops + value.NumberOfStops) === 0;
                const isOneRoomOccupency = HotelsRequest && HotelsRequest.Rooms && HotelsRequest.Rooms.length === 1;
                const isHotelsOnFlights = TRPCONFIG.Domain.HotelsOnFlightsEnabled && isFlightType && FlexibleTripType && !PackageId && isDirectFlight && isOneRoomOccupency;
                const selectedCheckIn = dateUtil.parseDate(hotelsRequest.CheckInDate);
                const selectedCheckOut = dateUtil.parseDate(hotelsRequest.CheckOutDate);
                const flightCheckIn = flightArrival ? dateUtil.parseDate(getCheckInDateForFlight(flightArrival)) : flightArrival;
                const flightCheckout = flightReturn ? dateUtil.parseDate(getCheckOutDateForFlight(flightReturn)) : flightReturn;
                const ekReferrer = cookieService.get('CampaignReferrer');
                let nextRoute = getRedirectUrlAfterSelectFlight(isHolidayType, isHotelsOnFlights, forceRedirectToOptions, tripId, oldAndNewFlightDatesMatch, preselectedHotelData);
                const timeRangeChangeDurationPoppup = flightArrival ? (flightArrival.getHours() >= TRPCONFIG.Domain.DepartureFlightCutOff && flightArrival.getHours() <= TRPCONFIG.Domain.HotelCheckInCutOffTime) : null;
                if (timeRangeChangeDurationPoppup && !ekReferrer) {
                    _block();
                    return showChangeHotelsDurationConfirmationPopup(flight).then(() => {
                        searchFlowAfterFlightSelection(trip, tripId, FlightsRequest, flight, BasketId, opts, PackageId,
                            isMultiDestHolidayType, isHolidayType, isHotelsOnFlights, nextRoute, params, forceRedirectToOptions, preselectedHotelData,
                            selectedCheckIn, selectedCheckOut, flightCheckIn, flightCheckout, isNewFlight, timeRangeChangeDurationPoppup, mobileParams);
                    });
                }
                if (!timeRangeChangeDurationPoppup || (ekReferrer && ekReferrer.length > 0)) {
                    searchFlowAfterFlightSelection(trip, tripId, FlightsRequest, flight, BasketId, opts, PackageId,
                        isMultiDestHolidayType, isHolidayType, isHotelsOnFlights, nextRoute, params, forceRedirectToOptions, preselectedHotelData,
                        selectedCheckIn, selectedCheckOut, flightCheckIn, flightCheckout, isNewFlight, timeRangeChangeDurationPoppup, mobileParams);
                }
            }
        });
    }

    function searchFlowAfterFlightSelection(trip, tripId, FlightsRequest, flight, BasketId, opts, PackageId,
        isMultiDestHolidayType, isHolidayType, isHotelsOnFlights, nextRoute, params, forceRedirectToOptions, preselectedHotelData,
        selectedCheckIn, selectedCheckOut, flightCheckIn, flightCheckout, isNewFlight, timeRangeChangeDurationPoppup, mobileParams) {
        return tripService.clearOptionalExtras(tripId).then(() => {
            if (!isNewFlight) {
                let newCheckIn = flightCheckIn;
                if (timeRangeChangeDurationPoppup && TRPCONFIG.Domain.ChangeHotelNightsDuration) {
                    const zeroTime = dateUtil.zeroTime(flightCheckIn, true);
                    flightCheckIn = dateUtil.addDays(zeroTime, -1, true);
                    newCheckIn = new Date(flightCheckIn);
                }
                oldAndNewFlightDatesMatch = false;
                oldAndNewFlightDatesMatch = ((newCheckIn && flightCheckout && selectedCheckIn && selectedCheckOut) &&
                                            ((flightCheckout.getDate() !== selectedCheckOut.getDate()) || (newCheckIn.getDate() !== selectedCheckIn.getDate()))) ?
                                            oldAndNewFlightDatesMatch : !oldAndNewFlightDatesMatch;
                nextRoute = getRedirectUrlAfterSelectFlight(isHolidayType, isHotelsOnFlights, forceRedirectToOptions, tripId, oldAndNewFlightDatesMatch, preselectedHotelData);
            }
            if (isHolidayType || isHotelsOnFlights) {
                const paramsCopy = { ...params, ...mobileParams };
                nextRoute = optionallyAppendParam(nextRoute, 'fid', paramsCopy && paramsCopy.fid);
            }
            if (FlightsRequest) {
                tripService.setSelectedFlight(tripId, flight, opts);

                const addFlightPromise = (
                    flight.isMultiDestHolidayLinked
                        ? basketStore.addMultiDestHolidayFlight
                        : basketStore.addFlight
                )(
                        FlightsRequest.AvailabilitySearchId,
                        flight,
                        BasketId,
                        tripId,
                        true,
                        opts,
                        PackageId
                    );

                if (!isMultiDestHolidayType && isFlightPreselected() && trip.TripType === 4) {
                    if (isHolidayType || isHotelsOnFlights) {
                        if (!nextRoute.includes('fbt=')) {
                            nextRoute = optionallyAppendParam(nextRoute, 'fbt', params && params.fbt);
                        }
                        if (!nextRoute.includes('fstr=')) {
                            nextRoute = optionallyAppendParam(nextRoute, 'fstr', params && params.fstr);
                        }
                        if (!nextRoute.includes('hpr=')) {
                            nextRoute = optionallyAppendParam(nextRoute, 'hpr', params && params.hpr);
                        }
                    }
                    $location.url(nextRoute);
                }
                //if we are in flight only mode here, we need to make sure that this cannot trigger a hotel search
                //due to dates being adjusted.
                return addFlightPromise.then(addFlightResponse => {
                    if (addFlightResponse) {
                        broker.publish('flightAddedToBasket', addFlightResponse);
                        service.updateBasket();
                        if (opts && opts.skipRedirection) {
                            return;
                        }
                        if (!isMultiDestHolidayType) {
                            if (isHolidayType || isHotelsOnFlights) {
                                if (!nextRoute.includes('fbt=')) {
                                    nextRoute = optionallyAppendParam(nextRoute, 'fbt', params && params.fbt);
                                }
                                if (!nextRoute.includes('fstr=')) {
                                    nextRoute = optionallyAppendParam(nextRoute, 'fstr', params && params.fstr);
                                }
                                if (!nextRoute.includes('hpr=')) {
                                    nextRoute = optionallyAppendParam(nextRoute, 'hpr', params && params.hpr);
                                }
                            }
                            $location.url(nextRoute);
                        }
                    }
                });
            }
        });
    }

    function getRedirectUrl(tripId, oldAndNewFlightDatesMatch, estabId) {
        if (urlStoreService.isPreviousUrlHotelDetails(tripId)) {
            return urlStoreService.getPreviousURL();
        }
        if (urlStoreService.isPreviousUrlHotelOptions(tripId) || urlStoreService.isPreviousUrlHotelBook(tripId)) {
            if (oldAndNewFlightDatesMatch) {
                return urlStoreService.getPreviousURL();
            }
            return estabId ? `holidays/${tripId}/${estabId}` : '';
        }
        return '';
    }

    function getRedirectUrlHotelFirstJourney(tripId, oldAndNewFlightDatesMatch, estabId) {
        if (oldAndNewFlightDatesMatch) {
            return `holidays/options/${tripId}`;
        }
        return estabId ? `holidays/${tripId}/${estabId}` : '';
    }

    function getRedirectUrlAfterSelectFlight(isHolidayType, isHotelsOnFlights, forceRedirectToOptions, tripId, oldAndNewFlightDatesMatch, hotelData) {
        const hotelDataJson = hotelData && JSON.parse(hotelData);
        const estabId = _.get(hotelDataJson, 'd.Itinerary.EstabId');
        let nextPath = (isHolidayType || isHotelsOnFlights) && !forceRedirectToOptions && sessionStorage.getItem('preselectedHotelData') === null ? 'hotels' : 'options';
        const backwardCompatibilityUrl = `holidays/${nextPath}/${tripId}`;

        switch (true) {
            case TRPCONFIG.Domain2.IsHotelFirstJourneyEnabled:
                return getRedirectUrlHotelFirstJourney(tripId, oldAndNewFlightDatesMatch, estabId) || backwardCompatibilityUrl;
            case TRPCONFIG.Domain2.EnableChangeFlightRedirectionToPrevious:
                return getRedirectUrl(tripId, oldAndNewFlightDatesMatch, estabId) || backwardCompatibilityUrl;
            default:
                return backwardCompatibilityUrl;
        }
    }

    function _compareFlights(selectedFlight, newFlight) {
        let isDifferentFlights = true;
        let isDatesMatch = false;
        if (selectedFlight && selectedFlight.FlightId !== undefined && newFlight.FlightId !== undefined) {
            isDifferentFlights = selectedFlight.FlightId !== newFlight.FlightId;
        }
        if (selectedFlight && selectedFlight.Legs !== undefined && selectedFlight.Legs[0] !== undefined && selectedFlight.Legs[1] !== undefined) {
            isDatesMatch = isCheckOutDatesMatched(selectedFlight.Legs[1].DepartureDate, newFlight.Legs[1].DepartureDate)
                && isCheckInDatesMatched(selectedFlight.Legs[0].ArrivalDate, newFlight.Legs[0].ArrivalDate);
        }
        return { isDifferentFlights, isDatesMatch };
    }

    function isCheckInDatesMatched(date1, date2) {
        date1 = getCheckInDateForFlight(getIOSDateFormat(date1));
        date2 = getCheckInDateForFlight(getIOSDateFormat(date2));
        return $filter('date')(date1, 'dd MM yy') === $filter('date')(date2, 'dd MM yy');
    }

    function isCheckOutDatesMatched(date1, date2) {
        date1 = getCheckOutDateForFlight(getIOSDateFormat(date1));
        date2 = getCheckOutDateForFlight(getIOSDateFormat(date2));
        return $filter('date')(date1, 'dd MM yy') === $filter('date')(date2, 'dd MM yy');
    }

    function getHotelDatesFromFlight(flight) {
        let checkInDate = _.get(flight, 'Legs[0].ArrivalDate');
        let checkOutDate = _.get(flight, 'Legs[1].DepartureDate');
        if (checkInDate && checkOutDate) {
                    checkInDate = getCheckInDateForFlight(getIOSDateFormat(checkInDate));
                    checkOutDate = getCheckOutDateForFlight(getIOSDateFormat(checkOutDate));
        }
        return [checkInDate, checkOutDate];
    }

    function getIOSDateFormat(paramDate) {
        const year = paramDate.split(/[- : T]/)[0];
        let month = paramDate.split(/[- : T]/)[1];
        month = Number(month) - 1;
        const day = paramDate.split(/[- : T]/)[2];
        const hour = paramDate.split(/[- : T]/)[3];
        const min = paramDate.split(/[- : T]/)[4];
        const second = paramDate.split(/[- : T]/)[5];

        if (month < 10) {
            month = `0${month}`;
        }

        const date = new Date(year, month, day, hour, min, second);
        return date;

    }
    function getNumberOfNightsFromFlights(...flights) {
        return flights.map(flight => {
                let checkInDate = _.get(flight, 'Legs[0].ArrivalDate');
                let checkOutDate = _.get(flight, 'Legs[1].DepartureDate');
                if (checkInDate && checkOutDate) {
                    checkInDate = getCheckInDateForFlight(getIOSDateFormat(checkInDate));
                    checkOutDate = getCheckOutDateForFlight(getIOSDateFormat(checkOutDate));
                    return dateUtil.numberOfNights(checkInDate, checkOutDate);
                }
                return undefined;
            });
    }

    async function changeToFlightWorkflow(tripId) {
        const { TripType } = await tripService.getTrip(tripId);
        const isHolidayType = TripType === tripService.tripTypes.Holiday;
        if (TRPCONFIG.Domain.HotelsOnFlightsEnabled && isHolidayType) {
            const { BasketId } = await tripService.changeTripType(tripId, tripService.tripTypes.Flight);
            await basketStore.removeAccomodation(BasketId);
            const basketStoreFlightResponse = await basketStore.flight(BasketId);
            broker.publish('flightAddedToBasket', basketStoreFlightResponse);
            service.updateBasket();
        }
        $timeout(() => $location.url(optionallyAppendParam(`/holidays/options/${tripId}`, 'fid', $routeParams && $routeParams.fid)));
    }

    async function changeToHolidayTripType(tripId) {
        if (TRPCONFIG.Domain.HotelsOnFlightsEnabled) {
            const packagePrice = await tripService.usePackageRates(tripId);
            if (!packagePrice) {
                const { TripType } = await tripService.getTrip(tripId);
                const isFlightType = TripType === tripService.tripTypes.Flight;
                if (isFlightType) {
                    return tripService.changeTripType(tripId, tripService.tripTypes.Holiday);
                }
            }
        }
    }

    function updateFlight(flight, tripId, opts, numBags) {
        tripService.getTrip(tripId).then(trip => {
            const holiday = trip.TripType === tripService.tripTypes.Holiday;
            if (trip) {
                tripService.clearOptionalExtras(tripId).then(() => {
                    if (trip.FlightsRequest) {
                        tripService.setSelectedFlight(tripId, flight, opts);
                        basketStore.addFlight(trip.FlightsRequest.AvailabilitySearchId, flight, trip.BasketId, tripId, holiday, opts, trip.PackageId)
                            .then(f => {
                                f.Details.Itinerary = _.assign({}, flight, f.Details.Itinerary);
                                broker.publish('flightAddedToBasket', f);
                                flightSearch.modifyBags(numBags);
                            });
                    }
                });
            }
        });
    }

    function selectMultiFlight(option, tripId) {
        const nextRoute = 'dp/basket/';

        tripService.getTrip(tripId).then(function(trip) {
            if (!trip || !trip.MultiFlightsRequest) {
                return;
            }

            basketStore.addMultiFlight(trip.MultiFlightsRequest.AvailabilitySearchId, option, trip.BasketId, tripId).then(function() {
                $location.path(nextRoute + tripId);
            });
        });
    }

    function getCarQuotes(basketId, tripId, driverAge) {
        return basketStore.flight(basketId).then(flight => {
            if (flight == null) {
                return $q.when([]);
            }
            return tripService.getTripReducedOccupancy(tripId).then(occ => {
                const legs = flight.Details.Itinerary.Legs;

                let request = _addCommonCarHireRequestCriteria(
                                {
                                    AvailabilitySearchId: guidService.uuid(),
                                    PickUpLocation: {
                                        Type: 2,
                                        Code: legs[0].ArrivalAirport.Code
                                    },
                                    DropOffLocation: {
                                        Type: 2,
                                        Code: legs[0].ArrivalAirport.Code
                                    },
                                    PickUpDate: dateUtil.roundedToStartOfHour(dateUtil.addHours(legs[0].ArrivalDate, TRPCONFIG.CarHireFlightDepartureOffset), true),
                                    DropOffDate: dateUtil.roundedToStartOfHour(dateUtil.addHours(legs[legs.length - 1].DepartureDate, TRPCONFIG.CarHireFlightReturnOffset), true),
                                    DriverAge: driverAge,
                                    PassengerCount: occ.Adults + occ.ChildAges.length
                                },
                                0
                              );

                return carHireService.getCarQuotes(tripId, request);
            });
        });
    }

    function getCarQuotesFromSession(searchId, pageIndex) {
        let request = _addCommonCarHireRequestCriteria({ AvailabilitySearchId: searchId }, pageIndex);
        return carHireService.getCarQuotesFromSession(request);
    }

    function _addCommonCarHireRequestCriteria(request, pageIndex) {
        return _.assign(request, {
                            SortCriterion: enumService.CarHireSortOrder.Recommended,
                            Paging: {
                                PageIndex: pageIndex,
                                PageSize: 5
                            }
                        });
    }

    function getParkingQuotes(searchId, basketId, tripId) {
        const _tidyAirportParkingTitles = quotes => {
            if (!quotes || quotes.length === 0) {
                return;
            }

            _.forEach(quotes, q => {
                q.CarPark = q.CarPark.replace(/\s+\(.*?\)\s*/g, '');
                q.CarPark = q.CarPark.replace(/(\s*-\s?(on|off)\sairport\s*)/gi, '');
            });

            return quotes;
        };

        if (!searchId) {
            return basketStore.flight(basketId).then(function(flight) {
                if (flight == null) {
                    return $q.when([]);
                }

                const legs = flight.Details.Itinerary.Legs;

                const request = {
                    AvailabilitySearchId: guidService.uuid(),
                    DepartureDate: legs[0].DepartureDate,
                    ReturnDate: legs.length > 1 ? legs[legs.length - 1].ArrivalDate : null,
                    AirportCode: legs[0].DepartureAirport.Code,
                    DepartureFlightNumber: legs[0].Segments[0].FlightNumber,
                    ReturnFlightNumber: legs.length > 1 ? legs[legs.length - 1].Segments[0].FlightNumber : null,
                    PassengerCount: flight.CostBreakdown[0].Quantity + 1,
                    DepartureTerminalCode: null
                };

                if (TRPCONFIG.Domain.AirportParkingUseTerminal === true) {
                    return flightsTerminalService.getTerminalsForAirport(request.AirportCode)
                        .then(airport => {
                            //if we know about the airport and it has more than one terminal use the terminal code
                            //to filter down our parking otherwise assume only one terminal
                            if (airport && airport.Terminals.length > 1) {
                                return flightsTerminalService.getTerminalForFlight(request.AirportCode,
                                                                                   request.DepartureFlightNumber,
                                                                                   request.DepartureDate)
                                    .then(terminal => {
                                        if (terminal) {
                                            request.DepartureTerminalCode = terminal.Code;

                                            return parkingService.getParkingQuotes(tripId, request)
                                                .then(quotes => _tidyAirportParkingTitles(quotes));
                                        }

                                        //record it if we don't have info on the terminal a flight is going from
                                        loggingService.logInfo(
                                            `No terminal information found for ${request.AirportCode} : ${request.DepartureFlightNumber} on ${request.DepartureDate}`
                                        );

                                        return $q.when(null);
                                    });
                            }
                            return parkingService.getParkingQuotes(tripId, request)
                                .then(quotes => _tidyAirportParkingTitles(quotes));
                        });
                }

                return parkingService.getParkingQuotes(tripId, request);
            });
        }

        return tripService.getTrip(tripId)
                .then(trip => {
                return parkingService.getParkingQuotesFromSession(searchId, trip.ParkingRequest)
                    .then(quotes => {
                        if (TRPCONFIG.Domain.AirportParkingUseTerminal === true) {
                            return _tidyAirportParkingTitles(quotes);
                        }
                        return quotes;
                    });
                });
    }

    function getAttractionQuotes(searchId, basketId, tripId) {
        if (searchId) {
            return attractionService.getAttractionQuotesFromSession(searchId);
        }

        return $q.all([
            currentDestination.getCurrentDestination(),
            basketStore.hotel(basketId),
            attractionService.getOccupancy(tripId),
            tripService.getHotelsRequestCheckInDate(tripId, true),
            tripService.getHotelsRequestCheckOutDate(tripId, true),
            tripService.getFlightsRequestDepartureDate(tripId, true),
            tripService.getFlightsRequestReturnDate(tripId, true)
        ]).then(function([dest, hotel, occ, checkInDate, checkOutDate, departureDate, returnDate]) {
            //Exactly one of ProvinceId and LocationId must be non-zero
            //we might be dealing with a polygon therefore try to fill in the details from the hotel
            if (!dest) { return; }

            let locationId = dest.LocationId;
            let locationType = dest.Type;

            if (!locationId) {
                if (hotel) {
                    locationId = hotel.Details.LocationId;
                    locationType = 2;
                } else {
                    locationId = dest.Id;
                }
            }

            return getQuotes();

            function getQuotes() {
                return attractionService.getAttractionQuotes(tripId, {
                    AvailabilitySearchId: guidService.uuid(),
                    Visitors: occ,
                    LocationId: locationId,
                    LocationType: locationType,
                    ProvinceId: 0,

                    StartDate: checkInDate || departureDate,
                    EndDate: checkOutDate || returnDate,

                    // to be removed
                    ProductItemId: 1
                });
            }
        });
    }

    function waitForFlight() {
        return flightIncompleteDates;
    }

    function updateBasket() {
        broker.publish('basketUpdated');
    }

    function bookingAlreadyDone(path) {
        return reason => {
            if (path != null && (`${$location.url()}`).search(/[\\/]options[\\/]/) >= 0) {
                let reasonString = 'unknown';
                try {
                    reasonString = JSON.stringify(reason || 'nothing');
                } catch (e) { }
                loggingService.logError(`Booking Already Done: ${path}, DomainId: ${TRPCONFIG.Domain.DomainId}, href: ${$location.absUrl()}}, reason: ${reasonString}`);
            }
            $location.path('bookingalreadydone');
        };
    }

    function isFlightPreselected() {
        return JSON.parse(sessionStorage.getItem('PreselectFlight'));
    }

    return service;
}
})();
